<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
  <fieldset class="k-form-fieldset">
    <kendo-formfield orientation="horizontal">
      <label class="k-label">
        <img [src]="imgURL" style="object-fit: contain;" width="100px" height="100px" shape="square" />
      </label>
      <kendo-fileselect (select)="selectAvatar($event)" [showFileList]="false" formControlName="imagem"
        [multiple]="false" [restrictions]="fileRestrictions">
        <kendo-fileselect-messages select="{{ customMsgService.translate('selecionarImagem') }}"
          dropFilesHere="{{ customMsgService.translate('largueAImagemAqui') }}">
        </kendo-fileselect-messages>
      </kendo-fileselect>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{
        customMsgService.translate('extensaoFicheiroNaoSuportada') }} </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="nome" [text]="customMsgService.translate('name')"> </kendo-label>
      <kendo-textbox formControlName="nome" [clearButton]="true" #nome required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('name') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" for="corPrincipal" [text]="customMsgService.translate('corPrincipal')">
      </kendo-label>
      <input kendoTextBox type="color" formControlName="corPrincipal" required />
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('corPrincipal') }} {{
        customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" for="corSecundaria" [text]="customMsgService.translate('corSecundaria')">
      </kendo-label>
      <input kendoTextBox type="color" formControlName="corSecundaria" required />
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('corSecundaria') }} {{
        customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>


    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="tipoSolucao" [text]="customMsgService.translate('solucao')"> </kendo-label>
      <kendo-dropdownlist formControlName="tipoSolucao" textField="description" valueField="id" [data]="lTiposSolucao"
        #tipoSolucao required>
      </kendo-dropdownlist>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('solucao') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

  </fieldset>

  <hr />
  <div class="k-form-buttons">
    <button kendoButton (click)="cancelChanges()">
      {{ customMsgService.translate('cancel') }}
    </button>
    <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>